import React from "react";
import { MyCafeteriaSzepApplicationCardPrint } from "my-cafeteria/components";

interface MyCafeteriaSzepApplicationPrintProps {
  applicationDate: string;
  employeeName: string;
  idNumber: string;
  contractCode: string;
  currentYear: number;
  hasPreviousBenefit: boolean;
  thisYear: number | string;
  data: any; // Replace `any` with a more specific type if possible
}

export class MyCafeteriaSzepApplicationPrint extends React.PureComponent<MyCafeteriaSzepApplicationPrintProps> {
  render() {
    const {
      applicationDate,
      employeeName,
      idNumber,
      contractCode,
      currentYear,
      hasPreviousBenefit,
      thisYear,
      data,
    } = this.props;

    return (
      <MyCafeteriaSzepApplicationCardPrint
        applicationDate={applicationDate}
        employeeName={employeeName}
        idNumber={idNumber}
        contractCode={contractCode}
        currentYear={currentYear}
        hasPreviousBenefit={hasPreviousBenefit}
        thisYear={typeof thisYear === "number" ? thisYear : Number(thisYear)}
        data={data}
      />
    );
  }
}

export default MyCafeteriaSzepApplicationPrint;
